<!--Desktop Banner-->
<div class="bg-primary pt-3 d-none d-lg-block" role="banner">
  <div class="container">
    <div class="d-none d-lg-flex text-white page-back-button-section align-items-center" [routerLink]="['/games']">
      <span class="material-icons me-2">arrow_back_ios_new</span>
    </div>
  </div>
</div>

<!--Mobile Navigation-->
<fgb-mobile-nav-menu [pageName]="'games.page.polls.title' | translate"></fgb-mobile-nav-menu>
<div class="bg-primary banner-image-container" role="banner">
  <div class="container">
    @if (isDefault) {
    <img class="polls-banner" [src]="'member/games/polls-banner.png' | contentAssetImage" alt="polls-banner" />
    } @if (isKid) { @if (kidType$ | async; as kidType) {
    <img
      class="polls-banner"
      [src]="
        (kidType == 'All-Stars' ? 'kids/games/allstars/polls-banner.png' : 'kids/games/baller/polls-banner.png')
          | contentAssetImage
      "
      alt="polls-banner"
    />
    } } @if (isClub1901) {
    <img class="polls-banner" [src]="'games/1901-polls-banner.png' | contentAssetImage" alt="polls-banner" />
    }
  </div>
</div>

<div class="container mobile-page-content">
  <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
    <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions" />
  </ng-container>

  <!-- Shimmer Effect -->
  <ng-template #shimmerEffect>
    <div class="card bg-primary" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
      <h6 class="card-title placeholder-glow text-center">
        <span class="question-shimmer-effect placeholder col-6"></span>
      </h6>
      <div class="answer-shimmer-effect-section">
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
      </div>
      <div class="answer-shimmer-effect-section mt-3">
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <p class="card-text placeholder-glow w-40 text-center">
          <span class="presentby-shimmer-effect placeholder col-7"></span>
        </p>
      </div>
    </div>
  </ng-template>
</div>
